"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaytimeRewardConfigSchema = exports.PlaytimeUnitSchema = exports.RewardSchema = exports.CumulativeRewardSchema = void 0;
const zod_1 = require("zod");
exports.CumulativeRewardSchema = zod_1.z.object({
    coinsCumulativePercentOfTotal: zod_1.z.number(),
    piggyBanksCumulativePercentOfTotal: zod_1.z.number(),
});
exports.RewardSchema = zod_1.z.object({
    coinsPercentOfTotal: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
    piggyBanksPercentOfTotal: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
});
exports.PlaytimeUnitSchema = zod_1.z.object({
    minutes: zod_1.z.number(),
    rewards: zod_1.z.union([exports.CumulativeRewardSchema, exports.RewardSchema]),
});
exports.PlaytimeRewardConfigSchema = zod_1.z.object({
    playtimeUnits: zod_1.z.array(exports.PlaytimeUnitSchema),
});
